module.exports = __webpack_public_path__ + "src/assets/vehicles/scooter-ogo.svg";